import { useEffect, useState } from "react";
import "./SpinWheel.css";
import { getWheelItems, updateWheelItem } from "../../api/wheelApi";

const REWARD_TYPES = ["Items", "Coins"];
const REWARD_CATEGORIES = ["Background", "Power ups", "Snake"];

export default function SpinWheel() {
  const [rows, setRows] = useState([]);
  const [openActionId, setOpenActionId] = useState(null);

  const fetchWheel = async () => {
    try {
      const data = await getWheelItems();

      const formatted = data?.data.map((item, index) => ({
        _id: item._id,
        srn: String(index + 1).padStart(2, "0"),

        rewardType: item.rewardType === "coins" ? "Coins" : "Items",

        rewardCategory: item.rewardCategory
          ? item.rewardCategory === "powerup"
            ? "Power ups"
            : item.rewardCategory.charAt(0).toUpperCase() +
              item.rewardCategory.slice(1)
          : "",

        // rewardValue: item.backgroundId || item.powerupId || item.snakeId || "",
        rewardValue: item.rewardValue.skin_id,

        rewardAmount: item.rewardAmount || 0,
        color: item.color || "#000000",
      }));

      setRows(formatted);
    } catch (err) {
      console.error("Failed to fetch wheel:", err);
    }
  };

  useEffect(() => {
    fetchWheel();
  }, []);

  const handleChange = async (id, field, value) => {
    setRows((prev) =>
      prev.map((row) => (row._id === id ? { ...row, [field]: value } : row)),
    );

    const row = rows.find((r) => r._id === id);
    if (!row) return;

    const payload = {
      rewardType: row.rewardType === "Coins" ? "coins" : "items",
      rewardCatagory:
        row.rewardCategory === "Power ups"
          ? "powerup"
          : row.rewardCategory.toLowerCase(),
      rewardAmount: row.rewardType === "Coins" ? Number(row.rewardAmount) : 0,
      color: row.color,
      backgroundId: row.rewardCategory === "Background" ? row.rewardValue : "",
      powerupId: row.rewardCategory === "Power ups" ? row.rewardValue : "",
      snakeId: row.rewardCategory === "Snake" ? row.rewardValue : "",
    };

    try {
      await updateWheelItem(id, payload);
    } catch (err) {
      console.error("Update failed:", err);
    }
  };

  const handleDuplicate = (id) => {
    setRows((prev) => {
      const row = prev.find((r) => r._id === id);
      if (!row) return prev;
      return [
        ...prev,
        {
          ...row,
          _id: Date.now().toString(),
          srn: String(prev.length + 1).padStart(2, "0"),
        },
      ];
    });
    setOpenActionId(null);
  };

  const handleDelete = (id) => {
    setRows((prev) => prev.filter((r) => r._id !== id));
    setOpenActionId(null);
  };

  return (
    <div className="spin-container">
      <div className="spin-header">
        <div className="spin-header-left">
          <h2>Spin Wheel</h2>
          <p>
            Find and retrieve your referrals, bonuses, and unique game items in
            one location.
          </p>
        </div>
      </div>

      <div className="spin-main">
        <div className="spin-table-wrapper">
          <table className="spin-table">
            <thead>
              <tr>
                <th>SRN</th>
                <th>Reward Type</th>
                <th>Reward Category</th>
                <th>Reward Value</th>
                <th>Reward Amount</th>
                <th>Color</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((row) => {
                const isCoins = row.rewardType === "Coins";

                return (
                  <tr key={row._id}>
                    <td>{row.srn}</td>

                    <td>
                      <select
                        value={row.rewardType}
                        onChange={(e) =>
                          handleChange(row._id, "rewardType", e.target.value)
                        }
                      >
                        {REWARD_TYPES.map((t) => (
                          <option key={t}>{t}</option>
                        ))}
                      </select>
                    </td>

                    <td>
                      <select
                        value={row.rewardCategory}
                        disabled={isCoins}
                        onChange={(e) =>
                          handleChange(
                            row._id,
                            "rewardCategory",
                            e.target.value,
                          )
                        }
                      >
                        <option value="">Select</option>
                        {REWARD_CATEGORIES.map((c) => (
                          <option key={c}>{c}</option>
                        ))}
                      </select>
                    </td>

                    <td>
                      <input
                        disabled={isCoins}
                        value={row.rewardValue}
                        onChange={(e) =>
                          handleChange(row._id, "rewardValue", e.target.value)
                        }
                      />
                    </td>

                    <td>
                      <input
                        type="number"
                        value={row.rewardAmount}
                        onChange={(e) =>
                          handleChange(row._id, "rewardAmount", e.target.value)
                        }
                      />
                    </td>

                    <td>
                      <input
                        type="color"
                        value={row.color}
                        onChange={(e) =>
                          handleChange(row._id, "color", e.target.value)
                        }
                      />
                    </td>

                    <td className="spin-action-cell">
                      <button
                        className="spin-dots-btn"
                        onClick={() =>
                          setOpenActionId(
                            openActionId === row._id ? null : row._id,
                          )
                        }
                      >
                        ⋮
                      </button>

                      {openActionId === row._id && (
                        <div className="spin-action-menu">
                          <button onClick={() => handleDuplicate(row._id)}>
                            Duplicate
                          </button>
                          <button onClick={() => handleDelete(row._id)}>
                            Delete
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
